import "./home.scss";
import Countdown from "../../components/countdown/countdown";
import Parallax from "../../components/parallax/parallax";
import { useEffect, useRef, useState } from "react";
import LoadingOverlay from "../../components/loading/LoadingOverlay";

// title
// date
// picture background
// scroll down for countdown
export default function Home() {
  const PAGE_TITLE = "THE RALLOS WEDDING";
  const WEDDING_DATE = "JUNE 11TH 2026";
  const [imagesLoaded, setImagesLoaded] = useState(false);

  // Example: custom hook to check when your images load
  useEffect(() => {
    const timeoutId = setTimeout(() => {
      setImagesLoaded(true);
    }, 1500);
    return () => clearTimeout(timeoutId);
  }, []);

  return (
    <>
      <LoadingOverlay isLoading={!imagesLoaded} />
      <div
        className={`home width-100 height-100 position-relative ${
          imagesLoaded ? "fade-in" : ""
        }`}
      >
        <div className="background-image"></div>
        <div className="home-wrapper position-relative overflow-hidden">
          {/* <Parallax className="background-image" /> */}
          <div className="title width-100 position-absolute text-center">
            <h1 className="cormorant-500 letter-spacing-11 font-size-14 margin-0">
              {PAGE_TITLE}
            </h1>
            <h2 className="cormorant-light-400 letter-spacing-2 font-size-6 margin-0">
              {WEDDING_DATE}
            </h2>
          </div>
        </div>
        {/* <div className="countdown position-relative text-center width-100">
          <Countdown />
        </div> */}
      </div>
    </>
  );
}
